import { connect } from 'react-redux'
import _ from 'lodash'

import PopupTypes from '../../popup_types'
import CCPopupsComponentSimGolf from '../../components/sim_golf/popups/cc_popups_component_sim_golf'
import {
  closePopup,
  openPopup,
  updateCategory,
  createCategory,
  changeLeagueCategory,
  changeLeagueSeason,
  changeLeagueName,
  changeLeagueTour,
  updateOpenRegistrationStatus,
  getLeagueFieldDataSimGolf,
  getLeaguePotentialCloneCandidate,
  updateCategoriesSimGolf,
  nextButton,
} from '../../actions'
import {
  getCategoriesOptions,
  getSeasonsOptions,
  getToursOptions,
} from '../../selectors'

const mapStateToProps = (state) => {
  const popupStates = state.popupStates

  const categoriesOptions = getCategoriesOptions(state)
  const changeCategory = {
    ...popupStates[PopupTypes.CHANGE_CATEGORY],
    categoriesOptions,
  }

  const seasonsOptions = getSeasonsOptions(state)
  const changeSeason = {
    ...popupStates[PopupTypes.CHANGE_SEASON],
    seasonsOptions,
  }

  const changeName = {
    ...popupStates[PopupTypes.CHANGE_NAME],
  }

  const userIsTourManager = state.misc.userIsTourManager
  const toursOptions = getToursOptions(state, { addEmptyOption: !userIsTourManager })
  const changeTour = {
    ...popupStates[PopupTypes.CHANGE_TOUR],
    toursOptions,
  }

  const createCloneEventLeague = {
    ...popupStates[PopupTypes.CREATE_CLONE_EVENT_LEAGUE],
    formURL: state.misc.cloneLeagueURL,
    customerOnlyEvents: state.misc.customerOnlyEvents,
  }

  return {
    categoriesOptions,
    seasonsOptions,
    toursOptions,
    createCloneEventLeague,
    categoryPopup: popupStates[PopupTypes.CATEGORY_POPUP],
    invitationListRegistrationPopup: popupStates[PopupTypes.INVITATION_LIST_REGISTRATION],
    existingTimesPopup: popupStates[PopupTypes.EXISTING_TIMES],
    changeCategory,
    changeSeason,
    changeName,
    changeTour,
    canCreateDCP: state.misc.canCreateDCP,
    userIsAdmin: state.misc.userIsAdmin,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    nextButton: data => dispatch(nextButton(PopupTypes.CREATE_CLONE_EVENT_LEAGUE, data)),
    closePopup: id => dispatch(closePopup(id)),
    updateCategory: data => dispatch(updateCategory(data.id, data)),
    updateCategoriesSimGolf: data => dispatch(updateCategoriesSimGolf(data)),
    createCategory: data => dispatch(createCategory(data)),
    changeLeagueCategory: (leagueId, toCategoryId) => {
      return dispatch(changeLeagueCategory(leagueId,
                                           toCategoryId))
    },
    changeLeagueSeason: (leagueId, seasonId) => dispatch(changeLeagueSeason(leagueId, seasonId)),
    changeLeagueName: (leagueId, name) => dispatch(changeLeagueName(leagueId, name)),
    changeLeagueTour: (leagueId, tourId) => dispatch(changeLeagueTour(leagueId, tourId)),
    updateOpenRegistrationStatus: (leagueId, status, skipNotifications) =>
      dispatch(updateOpenRegistrationStatus(leagueId, status, skipNotifications)),
    advanceToCopyOptions: (data) => dispatch(openPopup(PopupTypes.CLONE_EVENT_COPY_OPTIONS, data)),
    advanceToDates: (data) => dispatch(openPopup(PopupTypes.CLONE_EVENT_DATES, data)),
    getLeagueFieldDataSimGolf: (name) => dispatch(getLeagueFieldDataSimGolf(name)),
    getLeaguePotentialCloneCandidate: (leagueId) => dispatch(getLeaguePotentialCloneCandidate(leagueId)),
    advanceToInvitationList: (data) => dispatch(openPopup(PopupTypes.INVITATION_LIST_REGISTRATION, data)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CCPopupsComponentSimGolf)
